<template>
  <PageLoader class="mb-5 mt-5" v-if="isLoading"></PageLoader>

  <div id="offers-container" v-if="!isLoading">


    <snipp-offers
      :campaign-id="campaignId"
      :language="$t('Language')"
      @snipp-widget-event="handleSnippWidgetEvent"
      custom-css="https://snippcheck.blob.core.windows.net/files/OffersDemoCampaign/custom_overrides.css"
    ></snipp-offers>
    <div v-if="logged_out" class="d-none">
      <small
        >View all
        <a href="http://snipp.us/!cuRVc" target="_blank"
          >participating products and offers ></a
        ></small
      ><br />
      <small
        >Trouble participating? Check our
        <router-link to="/FAQ?havingTrouble" target="_blank"
          >FAQs ></router-link
        ></small
      >
    </div>
  </div>
</template>

<script>
import PageLoader from '../../../components/UI/PageLoader.vue';

export default {
  components: { PageLoader },
  props: ['campaignId'],
  data() {
    return {
      isLoading: true,
      logged_out: false, // Initialize as false
    };
  },
  methods: {
    handleSnippWidgetEvent(eventData) {
      if (eventData.detail && eventData.detail.length) {
        let message = eventData.detail[0];
        if (message.is_logged_out) this.logged_out = true;
        if (message.is_registered) this.logged_out = false;
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.isLoading = false;
    }, 1500);
  },
};
</script>
